var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const notNullOrUndefined = (value) => value !== null && value !== void 0;
const notEmptyObject = (value) => typeof value === "object" && Object.keys(value).length > 0;
const notEmptyArray = (value) => Array.isArray(value) && value.length > 0;
const notEmptyString = (value) => typeof value === "string" && value.length > 0;
const notEmptyParams = (value) => notNullOrUndefined(value) && (notEmptyObject(value) || notEmptyArray(value) || notEmptyString(value));
const prepareUrl = (value) => decodeURI(value).trim();
const getQuery = (params) => {
  const keys = notNullOrUndefined(params) ? Object.keys(params) : [];
  const lastKeyIndex = keys.length - 1;
  if (lastKeyIndex < 0) {
    return "";
  }
  return keys.reduce((acc, key, index) => {
    return `${acc}${key}=${params[key]}${index < lastKeyIndex ? "&" : ""}`;
  }, "?");
};
const reduceParamsFromArray = (array, paramsName) => {
  const result = {};
  array.forEach((exp, index) => {
    result[`${paramsName}${index + 1}`] = exp;
  });
  return result;
};
const getParamsKeys = (params) => {
  const result = [];
  if (!notEmptyParams(params)) {
    return result;
  }
  if (typeof params === "string") {
    result.push(params);
  } else if (Array.isArray(params)) {
    result.push(...params);
  } else {
    const [key] = Object.keys(params);
    const [value] = Object.values(params);
    result.push(key);
    result.push(...getParamsKeys(value));
  }
  return result;
};
class JtClickHouse {
  constructor(domain, version = "v1") {
    this._host = `https://analytics.${domain}/${version}/`;
  }
  sendPageView(params) {
    const { url = "", referrer = "", pageName: param2 } = params;
    const requestUrl = `${this._host}hits/pageview/`;
    const query = getQuery({
      url: prepareUrl(url),
      referrer: prepareUrl(referrer),
      param2
    });
    const xhr = new XMLHttpRequest();
    xhr.withCredentials = true;
    xhr.open("POST", requestUrl + query);
    xhr.send();
  }
  sendEvent(params) {
    const {
      url = "",
      referrer = "",
      eventName,
      experiments = [],
      params: eventParams
    } = params;
    const requestUrl = `${this._host}hits/event/`;
    const query = getQuery(__spreadValues(__spreadValues({
      url: prepareUrl(url),
      referrer: prepareUrl(referrer),
      eventName
    }, reduceParamsFromArray(experiments, "exp")), reduceParamsFromArray(getParamsKeys(eventParams), "params")));
    const xhr = new XMLHttpRequest();
    xhr.withCredentials = true;
    xhr.open("POST", requestUrl + query);
    xhr.send();
  }
}
export { JtClickHouse };
